import React from "react";
import { View } from "react-native";
import { useUnitReader } from "./units";

type GapProps = {
    gap?: number | string;
    mode?: "vertical" | "horizontal";
    grow?: boolean;
};
const Gap: React.FC<GapProps> = ({ gap, mode, grow }) => {
    const unitReader = useUnitReader();
    const effectiveGap = unitReader(gap);
    return (
        <View
            style={{
                height: mode !== "horizontal" ? effectiveGap : 0,
                width: mode !== "vertical" ? effectiveGap : 0,
                flexShrink: 0,
                flexGrow: grow ? 10 : 0,
            }}
        />
    );
};

export default Gap;
